export default {
      id: "download-usage",
      viewBox: "0 0 11.2 16.5",
      url: __webpack_public_path__ + "svg/sprite.svg#download",
      toString: function () {
        return this.url;
      }
    }